export const errorDescription = (error: unknown) => String(error)

export const errorStackTrace = (error: unknown) => {
  if (error instanceof Error) {
    return error.stack
  }
  return undefined
}

export type Prettify<T> = {
  [K in keyof T]: T[K]
} & {}
